<template>
  <div>
    <div v-if="displayPage == 'billing'" class="col-sm-12 col-xs-12 col-md-12 box-wrapper">
      <div v-for="plan in addedPlans" :key="plan.id">
        <div
          v-if="
            plan.id === 1 ||
            plan.id === 2 ||
            plan.id === 4 ||
            plan.id === 3 ||
            plan.id === 15 ||
            plan.id === 13 ||
            plan.id === 14 ||
            plan.id === 16 ||
            (plan.id === 7 && plan.service_type == 'premium') ||
            plan.id !== 7
          "
        >
          <div
            class="row service-charges"
            v-if="(plan.id === 7 && plan.service_type == 'premium') || plan.id !== 7"
          >
            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-10">
              <p class="white-space">{{ plan.name }}</p>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-2 col-xs-4 dollar-per-month"></div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <p v-if="plan.id === 2">${{ regIntelPrice }}/year</p>
              <p v-else>
                <span v-if="(plan.id === 7 && plan.service_type == 'premium') || plan.id !== 7"
                  >${{ plan.price }}/year</span
                >
              </p>
            </div>
          </div>
          <hr class="upper-line" />
          <div
            class="current-total"
            v-if="(plan.id === 7 && plan.service_type == 'premium') || plan.id !== 7"
          >
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-5">
                <p class="item-name">Last Bill due</p>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-5">
                <p>{{ plan.last_modified | dateFormat }}</p>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-2"></div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-5">
                <p class="item-name">Next Bill due</p>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-5">
                <p>{{ plan.valid_until | dateFormat }}</p>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-2"></div>
            </div>
            <hr class="billing-hr-line" />
          </div>
        </div>
      </div>
      <div>
        <div class="row service-charges" v-if="displayNoService">
          <div class="row m-0">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 team-member-reg pl-25">
              <notification-no-service @closepopup="$emit('closepopup')"></notification-no-service>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="row save-payment-method">
        <div class="col-lg-4 col-md-10 col-sm-10 col-xs-10">
          <p class="payment-method">Saved payment method</p>
        </div>
      </div>-->

      <div class="save-payment-method" v-if="addedPlans && addedPlans.length > 0">
        <!-- <div class="row">
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
            <p class="cred-card">Credit card</p>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-10">
            <p>xxxx xxxx xxxx 3222</p>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-2 edit-button">
            <p @click="changeContent('payment')">Edit</p>
        </div>-->
        <!-- <div class="col-lg-4 col-md-4 col-sm-4 col-xs-10 change-payment-left">
            <button class="change-payment" @click="changeContent">
              <span class="payment-font-size">Change Payment Method</span>
            </button>
        </div>-->
        <!-- </div> -->
        <!-- <hr class="billing-hr-line mr-lt-0" /> -->

        <div class="row" v-if="billingDetails && billingDetails.email_address">
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-10 billing-header">
            <p>Billing information</p>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-10">
            <p class="billing-address">
              {{ billingDetails.first_name }} {{ billingDetails.last_name }}
              <br />
              {{ billingDetails.email_address }}
              <br />
              {{ billingDetails.phone_number }}
              <br />
              {{ billingDetails.address }}
              <br />
              {{ billingDetails.city }}
              <br />
              {{ billingDetails.state }}
              <br />
              {{ billingDetails.country }}
              <br />
              {{ billingDetails.zipcode }}
            </p>
          </div>
          <!-- <div class="col-lg-4 col-md-4 col-sm-4 col-xs-2 edit-button">
            <p @click="changeContent('billinginfo')">Edit</p>
          </div>-->
        </div>
      </div>
      <div class="row" v-if="billingDetails && billingDetails.email_address">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 rams-billing">
          <p class="rams-billing-para">
            If you would like a copy of your invoices or having any billing questions email
            <a href="mailto:ramshelp@ul.com">RAMSHelp@ul.com</a>
          </p>
        </div>
      </div>
    </div>
    <div v-if="displayPage !== 'billing'" class="col-sm-12 col-xs-12">
      <hr />
    </div>
    <div v-if="displayPage == 'payment'" class="col-lg-12 col-md-12 col-sm-12 billingInfo">
      <div class="credit-payment-borderTable saved-payment-method">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-6">
            <input
              type="radio"
              id="save-card"
              name="payment-radio-group-mn"
              value="saved_card"
              v-model="payment_method"
            />
            <label class="default-card" for="save-card">Saved Payment Method</label>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6">
            <input type="checkbox" class="styled-checkbox" id="save-payment-method" />
            <label class="label-payment-method" for="save-payment-method"
              >Make default payment method</label
            >
          </div>
        </div>
        <div v-if="payment_method == 'saved_card'">
          <div class="row content">
            <div class="col-md-6 col-sm-6">
              <div class="form-group">
                <label for class="header-label">
                  Full Name (as it appears on card)
                  <span class="required_astric" v-if="!user_data.full_name">*</span>
                </label>
                <input
                  class="form-control"
                  :class="$v.user_data.full_name.$error ? 'invalid-border' : ''"
                  type="text"
                  placeholder="Full Name"
                  v-model.trim="$v.user_data.full_name.$model"
                />
                <div v-if="$v.user_data.full_name.$error">
                  <div class="custom-error-class" v-if="!$v.user_data.full_name.required">
                    Complete required field
                  </div>
                  <div class="custom-error-class" v-else-if="!$v.user_data.full_name.isFullName">
                    Please enter a valid name.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-6">
              <div class="form-group">
                <label for class="header-label">
                  Credit Card Number
                  <span class="required_astric" v-if="!user_data.credit_card_num">*</span>
                </label>
                <input
                  class="form-control"
                  :class="$v.user_data.credit_card_num.$error ? 'invalid-border' : ''"
                  type="text"
                  placeholder="Card Number"
                  v-model.trim="$v.user_data.credit_card_num.$model"
                  maxlength="17"
                />
                <div v-if="$v.user_data.credit_card_num.$error">
                  <div class="custom-error-class" v-if="!$v.user_data.credit_card_num.required">
                    Complete required field
                  </div>
                  <div
                    class="custom-error-class"
                    v-else-if="!$v.user_data.credit_card_num.isNumberCredit"
                  >
                    Please valid numbers
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row content">
            <div class="col-lg-6 col-md-6 col-sm-6 header-label">
              <label for class="header-label">Expiration Date</label>
              <span class="required_astric" v-if="!user_data.exp_date">*</span>
            </div>
          </div>
          <div class="row content">
            <div class="col-md-6 col-sm-6">
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                  <div class="form-group">
                    <label for class="header-label">Month</label>
                    <multiselect
                      class="multiselect-single-dropdown"
                      :class="!mnthvalue ? 'un-selected' : ''"
                      :options="arrMonth"
                      v-model="mnthvalue"
                      placeholder="MM"
                      :show-labels="false"
                      :allow-empty="false"
                      :searchable="false"
                    ></multiselect>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                  <div class="form-group">
                    <label for class="header-label">Year</label>
                    <multiselect
                      class="multiselect-single-dropdown"
                      :class="!yearValue ? 'un-selected' : ''"
                      :options="arrYear"
                      v-model="yearValue"
                      placeholder="YY"
                      :show-labels="false"
                      :allow-empty="false"
                      :searchable="false"
                    ></multiselect>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-6">
              <div class="form-group">
                <label for class="header-label">
                  Security code (CVV)
                  <span class="required_astric" v-if="!user_data.security_code">*</span>
                </label>
                <input
                  class="form-control"
                  :class="$v.user_data.security_code.$error ? 'invalid-border' : ''"
                  type="text"
                  placeholder="XXX"
                  v-model.trim="$v.user_data.security_code.$model"
                  maxlength="4"
                />
                <div v-if="$v.user_data.security_code.$error">
                  <div class="custom-error-class" v-if="!$v.user_data.security_code.required">
                    Complete required field
                  </div>
                  <div
                    class="custom-error-class"
                    v-else-if="!$v.user_data.security_code.isCreditCard"
                  >
                    Please enter valid CVV
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="row content">
            <div class="col-md-6 col-sm-6">
              <div class="form-group">
                <label for class="header-label">
                  First Name
                  <span class="required_astric" v-if="!user_data.first_name">*</span>
                </label>
                <input
                  class="form-control"
                  :class="$v.user_data.first_name.$error ? 'invalid-border' : ''"
                  v-model.trim="$v.user_data.first_name.$model"
                  type="text"
                  placeholder="First Name"
                  maxlength="65"
                />
                <div v-if="$v.user_data.first_name.$error">
                  <div class="custom-error-class" v-if="!$v.user_data.first_name.required">
                    Complete required field
                  </div>
                  <div class="custom-error-class" v-else-if="!$v.user_data.first_name.minLength">
                    Minimum 2 characters required.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-6">
              <div class="form-group">
                <label for class="header-label">
                  Last Name
                  <span class="required_astric" v-if="!user_data.last_name">*</span>
                </label>
                <input
                  class="form-control"
                  :class="$v.user_data.last_name.$error ? 'invalid-border' : ''"
                  type="text"
                  placeholder="Last Name"
                  v-model.trim="$v.user_data.last_name.$model"
                  maxlength="65"
                />
                <div v-if="$v.user_data.last_name.$error">
                  <div class="custom-error-class" v-if="!$v.user_data.last_name.required">
                    Complete required field
                  </div>
                  <div class="custom-error-class" v-else-if="!$v.user_data.last_name.minLength">
                    Minimum 2 characters required.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="credit-payment-borderTable">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-6">
            <input
              type="radio"
              id="newCredit-card"
              name="payment-radio-group-mn"
              value="new_card"
              v-model="payment_method"
            />
            <label class="default-card" for="newCredit-card">Add New Credit card</label>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6">
            <input type="checkbox" class="styled-checkbox" id="newCredit-payment-method" />
            <label class for="newCredit-payment-method">Make default payment method</label>
          </div>
        </div>
      </div>
      <div class="credit-payment-borderTable">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-6">
            <input
              type="radio"
              id="invoice-card"
              name="payment-radio-group-mn"
              value="invoice"
              v-model="payment_method"
            />
            <label class="default-card" for="invoice-card">Add Invoice</label>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6">
            <input type="checkbox" class="styled-checkbox" id="invoice-payment-method" />
            <label for="invoice-payment-method">Make default payment method</label>
          </div>
        </div>
      </div>
      <div class="credit-payment-borderTable">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-6">
            <input
              type="radio"
              id="purchase-card"
              name="payment-radio-group-mn"
              value="purchase_order"
              v-model="payment_method"
            />
            <label class="default-card" for="purchase-card">Add Purchase Order</label>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6">
            <input type="checkbox" class="styled-checkbox" id="purchase-payment-method" />
            <label for="purchase-payment-method">Make default payment method</label>
          </div>
        </div>
      </div>
    </div>

    <billing-info
      ref="billingInfo"
      :purchaseOrder="payment_method == 'purchase_order'"
      v-if="displayPage == 'billinginfo'"
    ></billing-info>

    <div
      v-if="displayPage == 'billinginfo' || displayPage == 'payment'"
      class="col-sm-12 col-xs-12 col-lg-12 col-md-12 mt-10"
    >
      <div class="col-md-2 col-md-offset-7 col-sm-offset-5 col-sm-3 col-xs-5 pr-0 xs-pd-lt-0">
        <button type="button" class="btn btn-block emergo-white-button" @click="navigateToMain">
          Cancel
        </button>
      </div>
      <div class="col-lg-3 col-md-3 col-sm-4 col-xs-7 pr-0 xs-pd-lt-0 xs-pd-rt-0">
        <button
          type="button"
          v-if="displayPage == 'payment'"
          @click="displayPage == 'payment' ? submitBillingInfo : null"
          class="btn btn-block emergo-green-button"
        >
          Save Changes
        </button>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>
<script>
import moment from 'moment';
import { validateData } from './BillingValidator';
import Loader from '../UIComponents/Loader.vue';
import BillingInfo from './PSM/BillingInfo.vue';
import { getSubscribedPlans, getPlanPrice } from '../../apis/plans';
import { getBillingInfo } from '../../apis/psm';
import NotificationNoService from './NotificationNoService.vue';
import {
  isAllCountriesSelected,
  getAvailableRegIntelCountries
} from '../../apis/regulatoryIntelligence';

export default {
  components: {
    Loader,
    BillingInfo,
    NotificationNoService
  },
  props: ['roleId', 'closeSubPage'],
  data() {
    return {
      displayNoService: true,
      regIntelPrice: 0,
      mnthvalue: '',
      yearValue: '',
      arrMonth: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      arrYear: [
        1990, 1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000, 2001, 2002, 2003, 2004,
        2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019,
        2020
      ],
      user_data: {
        full_name: '',
        credit_card_num: '',
        first_name: '',
        last_name: '',
        security_code: ''
      },
      loaderStatus: false,
      billDue: [
        {
          name: 'Last Bill due',
          date: '11/12/2019'
        },
        {
          name: 'Next Bill due',
          date: '12/12/2019'
        }
      ],
      displayPage: 'billing',
      payment_method: '',
      addedPlans: [],
      billingDetails: {}
    };
  },
  validations: {
    user_data: validateData
  },
  watch: {
    closeSubPage(val) {
      if (val === 'close') {
        this.navigateToMain();
      }
    }
  },
  methods: {
    async getAddedServiceDetails() {
      this.addedPlans = await getSubscribedPlans(
        JSON.parse(localStorage.getItem('userData')).account_id
      );
      if (this.addedPlans && this.addedPlans.length === 0) {
        this.displayNoService = true;
      } else if (this.addedPlans && this.addedPlans.length > 0) {
        this.displayNoService = false;
        this.addedPlans.forEach(async (plan, i) => {
          if (plan.id === 3) {
            this.addedPlans[i].price = await getPlanPrice(
              plan.id,
              JSON.parse(localStorage.getItem('userData')).account_id
            );
          }
          if (plan.id === 2) {
            await this.isAllCountriesSelected();
          }
        });
      }
    },
    async isAllCountriesSelected() {
      const allMarketsSelected = await isAllCountriesSelected(
        11,
        JSON.parse(localStorage.getItem('userData')).account_id
      );
      if (allMarketsSelected) {
        this.regIntelPrice = 599;
      } else {
        const selectedIds = await getAvailableRegIntelCountries(
          JSON.parse(localStorage.getItem('userData')).account_id
        );
        this.regIntelPrice = (selectedIds.length - 1) * 99;
      }
    },
    async getBillingInfo() {
      this.billingDetails = await getBillingInfo();
    },
    changeContent(page) {
      this.displayPage = page;
      if (this.displayPage === 'billinginfo' || this.displayPage === 'payment') {
        const breadCrumb =
          this.displayPage === 'billinginfo' ? 'Edit Billing information' : 'Change Payment Method';
        this.$emit('emitBreadCrumb', breadCrumb);
      } else {
        this.$emit('emitBreadCrumb', false);
      }
    },
    navigateToMain() {
      this.displayPage = 'billing';
      this.$emit('emitBreadCrumb', false);
    },
    submitBillingInfo() {
      this.$refs.billingInfo.$v.$touch();
      if (this.$refs.billingInfo.$v.$invalid) {
        return false;
      }
      return true;
    },
    async initializePage() {
      this.loaderStatus = true;
      await this.getAddedServiceDetails();
      await this.getBillingInfo();
      this.loaderStatus = false;
    }
  },
  mounted() {
    this.initializePage();
    this.displayPage = 'billing';
  },
  filters: {
    dateFormat(date) {
      if (date) {
        return moment(date).format('MM/DD/YYYY');
      }
      return '';
    }
  }
};
</script>
<style lang="scss" scoped>
.mr-lt-0 {
  margin-left: 0px;
  &.billing-hr-line {
    margin-left: 0px;
  }
}
.billingInfo {
  overflow-y: auto;
  height: 64vh;
  overflow-x: hidden;
  .saved-payment-method {
    &.selected-box {
      border: 3px solid $light-green;
    }
  }
}
.box-wrapper {
  overflow-y: auto;
  max-height: calc(84vh - 100px);
  overflow-x: hidden;
  .service-charges {
    padding-left: 20px;
  }
  .upper-line {
    margin-left: 20px;
    margin-right: 32px;
  }
}
.current-total {
  padding-left: 20px;
  &.last {
    hr {
      margin-left: 0px;
    }
  }
  p {
    &.item-name {
      padding-left: 40px;
    }
  }
}
.billing-hr-line {
  margin-right: 32px;
}
.change-payment {
  background: $deep-white;
  border: 1px solid $primary;
  box-sizing: border-box;
  border-radius: $radius20;
  color: $primary;
  @include fontItems($font-16, 19px, $font-weight-medium);
  padding: 6px 14px;
  outline: none;
}
.save-payment-method {
  padding-left: 20px;
}
.payment-method {
  padding-bottom: 16px;
}
.change-payment-left {
  padding-right: 46px;
  padding-left: 0px;
  text-align: end;
}
.rams-billing {
  padding: 110px 38px 37px 57px;
  p {
    &.rams-billing-para {
      text-align: center;
      background: rgba(103, 177, 226, 0.2);
      padding: 20px 0px;
      border-radius: 6px;
      align-items: center;
      font-family: Roboto;
      font-style: normal;
      @include fontItems($font-14, 16px, $font-weight-normal);
      color: $black;
    }
  }
}
.service-charges p,
.billing-header p {
  font-weight: 300;
  font-size: $font-18;
  line-height: 21px;
  color: $dark-black-alpha;
}
.credit-payment-borderTable {
  border: 1px solid #d3d6d9;
  box-sizing: border-box;
  border-radius: $radius10;
  margin-top: 16px;
  padding: 18px 16px 18px 22px;
  margin-bottom: 8px;
}
.styled-checkbox {
  position: absolute;
  opacity: 0;
  & + label {
    position: relative;
    cursor: pointer;
    padding: 0;
    &:before {
      content: '';
      margin-right: 10px;
      margin-top: 4px;
      display: inline-block;
      vertical-align: text-top;
      width: 14px;
      height: 14px;
      border: 1px solid $primary;
      border-radius: 1px;
    }
  }
  &:checked {
    & + label {
      &:after {
        content: '';
        position: absolute;
        left: 2px;
        top: 10px;
        background: $white;
        width: 2px;
        height: 2px;
        box-shadow: 2px 0 0 white, 4px 0 0 white, 4px -2px 0 white, 4px -4px 0 white,
          4px -6px 0 white, 4px -8px 0 white;
        transform: rotate(45deg);
      }
      &:before {
        background: $primary;
      }
    }
  }
}
[type='radio']:checked,
[type='radio']:not(:checked) {
  position: absolute;
  left: -9999px;
}
[type='radio']:checked + label,
[type='radio']:not(:checked) + label {
  position: relative;
  padding-left: 28px;
  cursor: pointer;
}
[type='radio']:checked + label:before,
[type='radio']:not(:checked) + label:before {
  content: '';
  position: absolute;
  left: 0;
  top: 7px;
  width: 18px;
  height: 18px;
  border: 1px solid $primary;
  border-radius: 100%;
  background: $white;
}
[type='radio']:checked + label:after,
[type='radio']:not(:checked) + label:after {
  content: '';
  width: 12px;
  height: 12px;
  background: $primary;
  position: absolute;
  top: 10px;
  left: 3px;
  border-radius: 100%;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
[type='radio']:not(:checked) {
  & + label {
    &:after {
      opacity: 0;
      -webkit-transform: scale(0);
      transform: scale(0);
    }
  }
}
[type='radio']:checked {
  & + label {
    &:after {
      opacity: 1;
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
}
.default-card {
  font-size: $font-24;
  line-height: 28px;
  color: $dark-black-alpha;
}
.label-payment-method {
  font-size: $font-16;
  line-height: 19px;
  color: $dark-black-alpha;
}
.comn_border {
  background: $deep-white;
  border: 0.5px solid $black;
  box-sizing: border-box;
  border-radius: 3px;
}
.header-label {
  font-size: $font-14;
  line-height: 16px;
  color: $dark-black-alpha;
}
span {
  &.required_astric {
    color: red;
    font-size: $font-12;
    padding-left: 1px;
  }
}
.securityCode {
  width: 114px;
}
.custom-error-class {
  padding-top: 8px;
}
@media only screen and (max-width: 320px) {
  .box-wrapper {
    .service-charges {
      padding-left: 0px;
    }
    .upper-line {
      margin-left: 0px;
      margin-right: 0px;
    }
  }
  .service-charges {
    .dollar-per-month {
      margin-left: 65px;
    }
  }
  .current-total {
    p {
      &.item-name {
        padding-left: 0px;
      }
    }
  }
  .billing-hr-line {
    margin-right: 12px;
    margin-left: 0px;
  }
  .save-payment-method {
    padding-left: 0px;
  }
  .change-payment-left {
    padding-right: 0px;
    padding-left: 0;
    text-align: center;
  }
  .rams-billing {
    padding: 10px 18px 0px 17px;
  }
  .payment-method {
    padding-bottom: 0px;
  }
}

@media (min-width: 321px) and (max-width: 379px) {
  .box-wrapper {
    .service-charges {
      padding-left: 0px;
    }
    .upper-line {
      margin-left: 0px;
      margin-right: 0px;
    }
  }
  .service-charges {
    .dollar-per-month {
      margin-left: 65px;
    }
  }
  .current-total {
    p {
      &.item-name {
        padding-left: 0px;
      }
    }
  }
  .billing-hr-line {
    margin-right: 12px;
    margin-left: 0px;
  }
  .save-payment-method {
    padding-left: 0px;
  }
  .change-payment-left {
    padding-right: 0px;
    padding-left: 0;
    text-align: center;
  }
  .rams-billing {
    padding: 10px 18px 0px 17px;
  }
  .payment-method {
    padding-bottom: 0px;
  }
}

@media (min-width: 380px) and (max-width: 767px) {
  .box-wrapper {
    .service-charges {
      padding-left: 0px;
    }
    .upper-line {
      margin-left: 0px;
      margin-right: 0px;
    }
  }
  .service-charges {
    .dollar-per-month {
      margin-left: 65px;
    }
  }
  .current-total {
    p {
      &.item-name {
        padding-left: 0px;
      }
    }
  }
  .billing-hr-line {
    margin-right: 12px;
    margin-left: 0px;
  }
  .save-payment-method {
    padding-left: 0px;
  }
  .change-payment-left {
    padding-right: 0px;
    padding-left: 0;
    text-align: center;
  }
  .rams-billing {
    padding: 10px 18px 0px 17px;
  }
  .payment-method {
    padding-bottom: 0px;
  }
}
@media (min-width: 767px) and (max-width: 1024px) {
  .box-wrapper {
    max-height: 46vh;
  }
}
@media screen and (width: 768px) {
  .box-wrapper {
    max-height: 52vh;
  }
}
@media screen and (min-width: 768px) {
  .save-payment-method {
    .cred-card {
      padding-left: 40px;
    }
  }
}
@media (min-width: 1025px) and (max-width: 1280px) {
  .white-space {
    white-space: nowrap;
  }
}
/* iphoneX landscape  */
@media (device-width: 812px) and (device-height: 375px) {
  .box-wrapper {
    max-height: 60vh;
  }
}
/* iphone5 landscape and below */
@media (max-width: 640px) and (max-height: 360px) {
  .box-wrapper {
    max-height: 55vh;
  }
}
/* iphone 6 and 6+ landscape  */
@media (device-width: 736px) and (device-height: 414px),
  (device-width: 667px) and (device-height: 375px) {
  .box-wrapper {
    max-height: 60vh;
  }
}
</style>
